// A 404 for a conversation is a definite answer (it was deleted), not a
// transient error. Callers use this to forget the id and stop polling it.
export function isConversationNotFound(err: unknown): boolean {
  return (err as { status?: number } | null)?.status === 404;
}

export function handleRestoreFailure(
  err: unknown,
  sessionStorageKey: string,
): void {
  // Ignore "not configured" errors - effect will re-run when
  // ChatProvider sets config and loadConversation gets a new reference
  if ((err as { message?: string })?.message?.includes("not configured")) {
    return;
  }
  console.error("[IDA Restore] loadConversation failed:", err);
  // Keep the saved pointer (sessionStorageKey) on load failure. The
  // conversation still exists and still appears in the history list -
  // clearing the pointer here only meant the next reload landed on a
  // blank welcome screen instead of retrying the same conversation.
}
